export const RAV_ONE_ROUTES = {
  history: '/antecipacao/one/historico',
  editValue: '/antecipacao/one/editar-valor',
  spot: {
    form: '/antecipacao/one/pontual/formulario',
    confirm: '/antecipacao/one/pontual/confirmar',
    password: '/antecipacao/one/pontual/senha',
    success: '/antecipacao/one/pontual/sucesso'
  },
  automatic: {
    form: '/antecipacao/one/automatica/formulario',
    confirm: '/antecipacao/one/automatica/confirmar',
    password: '/antecipacao/one/automatica/senha',
    success: '/antecipacao/one/automatica/sucesso',
    deactivate: '/antecipacao/one/automatica/desativar',
    deactivated: '/antecipacao/one/automatica/desativado'
  },
  shortSpot: {
    confirm: '/antecipacao/one/pontual-rapida/confirmar',
    result: '/antecipacao/one/pontual-rapida/resultado'
  }
} as const
